export default "__VITE_ASSET__DoqJ5nyn__"